// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum FacilityCountBaselineSource {
	Manual = 0,
	GroundTruth = 1,
}

export const FacilityCountBaselineSourceDisplayNames: { [key in keyof typeof FacilityCountBaselineSource]?: string} = {
	"Manual": "Manual",
	0 : "Manual",
	"GroundTruth": "Ground Truth",
	1 : "Ground Truth",
}

export const getFacilityCountBaselineSourceDisplayName = (key: FacilityCountBaselineSource | (keyof typeof FacilityCountBaselineSource & string)) => {
	return FacilityCountBaselineSourceDisplayNames[key];
}

